(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('anam-multicolumn-v2')) {
  customElements.define('anam-multicolumn-v2', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.list = this.querySelector('ul');
      this.originals = [...this.list.children];
      this.controls = this.querySelector('.anam-controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true';
      this.hover = false; this.focus = false; this.drag = false; this.selected = false;
      this.classList.add('is-ready');
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.abort.signal });
      on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hover = true; this.schedule(); } });
      on(this, 'pointerleave', () => { this.hover = false; this.schedule(); });
      on(this, 'focusin', e => {
        const clone = e.target.closest('[data-anam-clone]');
        if (clone) {
          const original = this.originals[Number(clone.dataset.anamClone)];
          const index = [...clone.querySelectorAll('a, button, input, select, textarea, [tabindex]')].indexOf(e.target);
          this.list.scrollLeft += this.position(original) - this.position(clone);
          const target = original.querySelectorAll('a, button, input, select, textarea, [tabindex]')[index];
          if (target) target.focus({ preventScroll: true });
        }
        this.focus = this.hasKeyboardFocus(); this.schedule();
      });
      on(this, 'focusout', () => queueMicrotask(() => { this.focus = this.hasKeyboardFocus(); this.schedule(); }));
      on(this.list, 'pointerdown', e => {
        if (!this.active || e.isPrimary === false || e.button !== 0) return;
        this.stopAnimation(); this.normalize();
        this.pointer = e.pointerId; this.pointerX = e.clientX; this.pointerY = e.clientY;
        this.gestureStart = Math.round((this.list.scrollLeft - this.base) / this.step);
        this.travel = 0; this.swiping = false; this.drag = true; this.schedule();
      });
      on(window, 'pointermove', e => {
        if (e.pointerId !== this.pointer || !this.drag) return;
        const dx = e.clientX - this.pointerX;
        if (!this.swiping) {
          if (Math.abs(dx) < 8) return;
          if (Math.abs(e.clientY - this.pointerY) > Math.abs(dx)) { this.drag = false; this.pointer = null; this.schedule(); return; }
          this.swiping = true;
          this.list.style.scrollSnapType = 'none';
          this.list.setPointerCapture(e.pointerId);
        }
        this.travel += dx; this.pointerX = e.clientX;
        this.writePosition(this.list.scrollLeft - dx);
        this.buttons();
      });
      const release = e => {
        if (e.pointerId !== this.pointer) return;
        const swiped = this.swiping;
        this.drag = false; this.swiping = false; this.pointer = null;
        if (this.list.hasPointerCapture(e.pointerId)) this.list.releasePointerCapture(e.pointerId);
        if (swiped) {
          this.suppressClick = true;
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 400);
          const distance = Math.abs(this.travel);
          const count = distance >= 20 ? Math.max(1, Math.round(distance / this.step)) : 0;
          const index = this.gestureStart - Math.sign(this.travel) * count;
          const n = this.originals.length;
          const logical = this.loop ? ((index % n) + n) % n : Math.max(0, Math.min(n - 1, index));
          let target = this.base + logical * this.step;
          if (this.loop) {
            while (target - this.list.scrollLeft > this.period / 2) target -= this.period;
            while (this.list.scrollLeft - target > this.period / 2) target += this.period;
          }
          this.animateTo(target);
        } else this.list.style.scrollSnapType = '';
        this.schedule();
      };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', release);
      on(this.list, 'lostpointercapture', release);
      this.list.addEventListener('click', e => {
        if (this.suppressClick) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, { capture: true, signal: this.abort.signal });
      on(this.list, 'dragstart', e => e.preventDefault());
      on(this.list, 'wheel', () => { this.stopAnimation(); this.schedule(); });
      on(this.list, 'scroll', () => {
        clearTimeout(this.settle);
        if (!this.animating && !this.selected) this.normalize();
        this.schedule();
        this.settle = setTimeout(() => {
          if (this.drag || this.animating || this.selected || !this.step) return;
          this.normalize();
          const target = this.base + Math.round((this.list.scrollLeft - this.base) / this.step) * this.step;
          if (Math.abs(this.list.scrollLeft - target) > 1) this.animateTo(target);
        }, 140);
      });
      on(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
      on(this.querySelector('[data-next]'), 'click', () => this.move(1));
      on(document, 'visibilitychange', () => this.recoverPlayback());
      on(window, 'pageshow', () => this.recoverPlayback());
      on(this.motion, 'change', () => { this.stopAnimation(); this.schedule(); });
      on(document, 'shopify:block:select', e => {
        const card = this.originals.find(el => el === e.target || el.contains(e.target));
        if (!card) return;
        this.selected = true; this.stopAnimation();
        this.list.scrollLeft = this.position(card); this.schedule();
      });
      on(document, 'shopify:block:deselect', () => { this.selected = false; this.schedule(); });
      this.resize = new ResizeObserver(() => this.layout()); this.resize.observe(this.list);
      this.intersection = new IntersectionObserver(entries => {
        const visible = entries[0].isIntersecting;
        if (visible === this.visible) return;
        this.visible = visible; this.recoverPlayback();
      });
      this.intersection.observe(this);
      this.layout();
    }
    hasKeyboardFocus() {
      const focused = document.activeElement;
      return !!focused && this.contains(focused) && focused.matches(':focus-visible');
    }
    recoverPlayback() {
      this.stopAnimation();
      const pointer = this.pointer;
      this.drag = false; this.swiping = false; this.pointer = null;
      if (pointer != null && this.list.hasPointerCapture(pointer)) this.list.releasePointerCapture(pointer);
      this.hover = matchMedia('(hover: hover)').matches && this.matches(':hover');
      this.focus = this.hasKeyboardFocus();
      this.lastMove = performance.now();
      this.schedule();
    }
    position(el) {
      const left = el.getBoundingClientRect().left - this.list.getBoundingClientRect().left + this.list.scrollLeft;
      return left - (matchMedia('(max-width: 749px)').matches ? (this.list.clientWidth - el.getBoundingClientRect().width) / 2 : 0);
    }
    stopAnimation() { cancelAnimationFrame(this.frame); this.animating = false; if (this.list) this.list.style.scrollSnapType = ''; }
    layout() {
      this.stopAnimation();
      const oldIndex = this.step ? Math.round((this.list.scrollLeft - (this.base || 0)) / this.step) : 0;
      this.querySelectorAll('[data-anam-clone]').forEach(el => el.remove());
      const n = this.originals.length;
      this.step = n ? this.originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.list).columnGap || 0) : 0;
      this.active = n > 1 && this.step * n - parseFloat(getComputedStyle(this.list).columnGap || 0) > this.list.clientWidth + 1;
      this.loop = this.active && this.dataset.loop === 'true';
      if (this.loop) {
        const copy = () => this.originals.map((el, index) => {
          const clone = el.cloneNode(true);
          clone.dataset.anamClone = String(index); clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id'); node.removeAttribute('data-shopify-editor-block');
            node.removeAttribute('data-cascade'); node.classList.remove('scroll-trigger', 'animate--slide-in');
            if (node.matches('a, button, input, select, textarea, [tabindex]')) node.setAttribute('tabindex', '-1');
          });
          return clone;
        });
        this.list.prepend(...copy()); this.list.append(...copy());
      }
      this.base = this.loop ? this.position(this.originals[0]) : 0;
      this.period = this.step * n;
      this.list.scrollLeft = this.base + (this.loop ? ((oldIndex % n) + n) % n : Math.max(0, oldIndex)) * this.step;
      this.controls.hidden = !this.active;
      this.buttons(); this.schedule();
    }
    writePosition(value) {
      let x = value;
      if (this.loop && this.period > 0) {
        while (x < this.base - 1) x += this.period;
        while (x >= this.base + this.period - 1) x -= this.period;
      }
      if (Math.abs(x - this.list.scrollLeft) > 0.1) this.list.scrollLeft = x;
    }
    normalize() {
      this.writePosition(this.list.scrollLeft);
      this.buttons();
    }
    buttons() {
      this.querySelector('[data-prev]').disabled = !this.loop && this.list.scrollLeft <= 1;
      this.querySelector('[data-next]').disabled = !this.loop && this.list.scrollLeft >= this.list.scrollWidth - this.list.clientWidth - 1;
    }
    move(direction) {
      if (!this.active || this.animating) return;
      this.normalize();
      const start = this.list.scrollLeft;
      const target = Math.max(0, Math.min(this.list.scrollWidth - this.list.clientWidth, this.base + (Math.round((start - this.base) / this.step) + direction) * this.step));
      this.animateTo(target);
    }
    animateTo(destination) {
      this.stopAnimation();
      const start = this.list.scrollLeft;
      const target = Math.max(0, Math.min(this.list.scrollWidth - this.list.clientWidth, destination));
      if (this.motion.matches) { this.list.style.scrollSnapType = ''; this.list.scrollLeft = target; this.normalize(); this.schedule(); return; }
      this.lastMove = performance.now();
      this.animating = true;
      this.list.style.scrollSnapType = 'none';
      const time = performance.now();
      const tick = now => {
        const p = Math.min(1, (now - time) / 220);
        this.list.scrollLeft = start + (target - start) * (1 - Math.pow(1 - p, 3));
        if (p < 1) this.frame = requestAnimationFrame(tick);
        else { this.animating = false; this.list.style.scrollSnapType = ''; this.normalize(); this.schedule(); }
      };
      this.frame = requestAnimationFrame(tick);
    }
    schedule() {
      clearTimeout(this.timer);
      this.focus = this.hasKeyboardFocus();
      if (this.animating) return;
      if (!this.active || this.paused || this.motion.matches || this.hover || this.focus || this.drag || this.selected || !this.visible || document.hidden) { this.lastMove = performance.now(); return; }
      if (!this.loop && this.list.scrollLeft >= this.list.scrollWidth - this.list.clientWidth - 1) return;
      this.timer = setTimeout(() => this.move(1), Math.max(100, (Number(this.dataset.interval) || 4000) - (performance.now() - (this.lastMove || performance.now()))));
    }
    disconnectedCallback() {
      this.abort.abort(); this.resize.disconnect(); this.intersection.disconnect();
      clearTimeout(this.timer); clearTimeout(this.settle); clearTimeout(this.clickTimer); this.stopAnimation();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
